import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBold = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 6,
	viewBox: "0 0 8 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.34856 0.934344C7.66098 1.24676 7.66098 1.75329 7.34856 2.06571L4.06571 5.34856C3.7533 5.66098 3.24676 5.66098 2.93434 5.34856L0.651501 3.06571C0.339081 2.7533 0.339081 2.24676 0.651501 1.93434L0.934344 1.6515C1.24676 1.33908 1.75329 1.33908 2.06571 1.6515L3.35861 2.94439C3.43671 3.0225 3.56335 3.0225 3.64145 2.94439L5.93434 0.651501C6.24676 0.339082 6.75329 0.339081 7.06571 0.651501L7.34856 0.934344Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckBold);
export { ForwardRef as ReactComponent };
